import React from 'react';

export const Download = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--download';
  color = color || '#0076CC';

  return (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M5.615 17.0001H3C2.46957 17.0001 1.96086 16.7894 1.58579 16.4143C1.21071 16.0393 1 15.5306 1 15.0001V3.00012C1 2.46969 1.21071 1.96098 1.58579 1.58591C1.96086 1.21084 2.46957 1.00012 3 1.00012H11C11.5304 1.00012 12.0391 1.21084 12.4142 1.58591C12.7893 1.96098 13 2.46969 13 3.00012V5.54558"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4.99988H8"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 9H6"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.9092L13 17.9092L16 14.9092"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 17.9092V8.90918"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Download;
